import { Link } from "@inertiajs/react";

export const ConditionalLink = ({
    inertia,
    href,
    external = false,
    ...props
}) => {
    const externalProps = { target: "_blank", rel: "noopener" };
    return inertia ? (
        <Link href={href} {...props} {...(external ? externalProps : {})} />
    ) : (
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        <a href={href} {...props} {...(external ? externalProps : {})} />
    );
};
